<template>
	<div>
		<div class="card shadow-sm mb-4">
			<div class="card-header">
				<button class="btn btn-light" style="position: absolute; right: 0.5em; top: 0.5em;" @click.prevent="refreshProject"><i class="fas fa-sync-alt"></i> Refresh</button>
				<h4 class="my-0 font-weight-normal">Project Settings</h4>
			</div>
			<div class="card-body">
				<form autocomplete="off">
					<div class="form-group">
						<label for="projectSettings_title">Title</label>
						<input v-model="projectSettings.title" type="text" class="form-control" id="projectSettings_title" aria-describedby="projectSettings_titleHelp" placeholder="Enter title">
						<small id="projectSettings_titleHelp" class="form-text text-muted">Descriptive title (e.g. "Joe's Project #2")</small>
					</div>
					<div class="form-group">
						<label for="projectSettings_desc">Description</label>
						<textarea v-model="projectSettings.description" type="text" class="form-control" id="projectSettings_desc" aria-describedby="projectSettings_descHelp" placeholder="Enter description" rows="2"></textarea>
						<small id="projectSettings_descHelp" class="form-text text-muted">Descriptive details (e.g. "This project is created for testing.")</small>
					</div>
					<div class="form-group">
						<label for="projectSettings_owner">Transfer to Another Account</label>
						<select v-model="newOwner" class="form-control" id="projectSettings_owner" aria-describedby="projectSettings_ownerHelp">
							<option :value="null">(No change)</option>
							<option v-if="projectSettings.owner != account.$id" v-for="( account, index ) in accountList" :key="index" :value="account.$id">
								{{account.name}} ({{account.$id}})
							</option>
						</select>
						<small id="projectSettings_ownerHelp" class="form-text text-muted">Transfer the project to another account (only owners and administrators can do this)</small>
					</div>
					<div class="form-check mb-3">
						<input v-model="projectSettings.public" type="checkbox" class="form-check-input" id="projectSettings_public">
						<label class="form-check-label" for="projectSettings_public" aria-describedby="projectSettings_publicHelp">Public <small class="text-muted">(discoverable by any valid API key or account)</small></label>
					</div>

					<div class="form-group">
						<label>Sharing Permissions</label>
						<table class="table table-bordered table-hover table-responsive">
							<thead>
								<tr>
									<th scope="col" style="width: 100%;">Account Name <em class="text-muted">(ID)</em></th>
									<th scope="col" class="text-center" style="min-width: 80px;"><em>None</em></th>
									<th scope="col" class="text-center" style="min-width: 80px;">Read</th>
									<th scope="col" class="text-center" style="min-width: 80px;">Write</th>
									<th scope="col" class="text-center table-danger" style="min-width: 80px;">Admin</th>
								</tr>
							</thead>
							<tbody>
								<tr v-for="account in accountList" :key="account.$id">
									<th scope="row" class="font-weight-normal">{{account.name}} <em class="text-muted">({{account.$id}})</em></th>
									<td class="text-center"><input v-model="projectSharing[account.$id]" type="radio" :value="undefined" :name="account.$id"></td>
									<td class="text-center"><input v-model="projectSharing[account.$id]" type="radio" value="read" :name="account.$id"></td>
									<td class="text-center"><input v-model="projectSharing[account.$id]" type="radio" value="write" :name="account.$id"></td>
									<td class="text-center table-danger"><input v-model="projectSharing[account.$id]" type="radio" value="admin" :name="account.$id"></td>
								</tr>
								<tr v-for="( checkedValue, accountId ) in manualAccountsProjectSharing" :key="accountId" v-if="accountList.length <= 1">
									<th scope="row" class="font-weight-normal">{{checkedValue}}
										<em v-if="checkedValue != accountId" class="text-muted">({{accountId}})</em>
									</th>
									<td class="text-center"><input v-model="projectSharing[accountId]" type="radio" :value="undefined" :name="accountId"></td>
									<td class="text-center"><input v-model="projectSharing[accountId]" type="radio" value="read" :name="accountId"></td>
									<td class="text-center"><input v-model="projectSharing[accountId]" type="radio" value="write" :name="accountId"></td>
									<td class="text-center table-danger"><input v-model="projectSharing[accountId]" type="radio" value="admin" :name="accountId"></td>
								</tr>
								<tr v-if="accountList.length <= 1">
									<td colspan="5">
										<div class="form-row">
											<div class="col">
												<label for="manualAddUser" class="col-form-label">Add known username:</label>
											</div>
											<div class="col">
												<input v-model="userCheckName" id="manualAddUser" type="text" pattern="[a-zA-Z0-9_]+" class="form-control" placeholder="Enter ID or Username">
											</div>
											<div class="col">
												<button class="btn btn-secondary" @click.prevent="addManualShareUser( )"><i class="fas fa-plus"></i> Add User</button>
											</div>
										</div>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div class="form-group">
						<button class="btn btn-success mt-4" @click.prevent="saveProjectSettings" ><i class="fas fa-save"></i> Save Project Settings</button>
						<button class="btn btn-secondary mt-4" @click.prevent="resetProject"><i class="fas fa-sync-alt"></i> Reset Form</button>
						<button class="btn btn-danger float-right mt-4" @click.prevent="deleteThisProject"><i class="fas fa-times"></i> Delete Project</button>
					</div>
					
				</form>
			</div>
		</div>

		<div class="card shadow-sm">
			<div class="card-header">
				<h4 class="my-0 font-weight-normal">Project Settings (JSON)</h4>
			</div>
			<div class="card-body">

				<div id="editor"></div>
				<button class="btn btn-success mt-4" @click.prevent="saveEditorProject"><i class="fas fa-save"></i> Save Settings</button>
				<button class="btn btn-secondary mt-4" @click.prevent="setEditorProject( )"><i class="fas fa-sync-alt"></i> Reset Editor</button>
				
			</div>
		</div>
	</div>
</template>

<script>

import 'ace-builds';
import 'ace-builds/webpack-resolver';

import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import _ from 'lodash';

export default {
	name: "project-dashboard",
	props: [ 'nodeId', 'projectId' ],
	data() {
		return {
			projectSettings : { },
			projectSharing : { },
			manualAccountsProjectSharing: { },
			userCheckName: "",
			newOwner: null,
			accountList : []
		};
	},
	watch:
	{
		projectSharing:
		{
			deep: true,
			handler: function( newValue, oldValue )
			{
				console.log( "New Sharing:", JSON.stringify( newValue, null, 2 ) );
				let sharing = { };
				for( let account in newValue )
				{
					let role = newValue[account];
					
					if( role == 'read' || role == 'write' || role == 'admin' )
						sharing[account] = { [role] : true };
					
				}
				this.$set( this.projectSettings, 'sharing', sharing );
			}
		},
		projectSettings:
		{
			handler: function( newValue, oldValue ) { this.setEditorProject( ); },
			deep : true
		}
	},
	computed:
	{
		currentSession: function( )
		{
			try {
				let sessionGuid = this.activeSession( this.nodeId );
				let [ sNode, sKey ] = sessionGuid.split( "/" );
				let session = this.session( sessionGuid );
				return session;
			} catch( err ) { }
			return null;
		},
		...mapGetters( "accounts", {
			account: "account",
		}),
		...mapGetters( "authentication", {
			activeSession: "activeSession",
			session: "session"
		}),
	},
	methods:
	{
		...mapActions({
			listAccounts: "accounts/list",
			checkAccount: "accounts/checkAccount",
		}),
		async addManualShareUser( checkName )
		{
			checkName = checkName || this.userCheckName;
			if( !checkName )
				return alert( "You must provide a username or ID to add a user." );
			let account = await this.checkAccount( { nodeId : this.nodeId, checkName } );
			if( !account )
				return alert( "No account found with this username or ID" );
			console.log( "ACCOUNT:", account );
			let id = account.$id;
			if( this.manualAccountsProjectSharing.hasOwnProperty( id ) )
				return alert( "This account is already in the sharing list:\nID: "+ id );
			this.$set( this.manualAccountsProjectSharing, id, this.userCheckName );
			this.userCheckName = "";
		},
		async saveProjectSettings( )
		{
			let project = this.projectSettings;

			let id = this.getProject( ).$id;

			try {
				let updates = _.omit( project, [ '$created', '$modified', '$version', '$node', 'owner' ] );
				if( this.newOwner )
					updates.owner = this.newOwner;
				let result = await this.updateProject( { nodeId : this.nodeId, projectId : id, updates : updates } );
				if( !id || null === result )
					throw new Error( "This project is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Project save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'projects', params : { nodeId : this.nodeId } } );
			}
		},
		async refreshProject( )
		{
			// TODO: Start Loading
			await this.readProject( { nodeId : this.nodeId, projectId : this.projectId, nocache : true } );
			this.resetProject( );
			// TODO: End Loading
		},
		async deleteThisProject( )
		{
			if( !confirm( "Are you sure you want to delete this project?" ) )
				return;
			try {
				let result = await this.deleteProject( { nodeId : this.nodeId, projectId : this.projectId } );
				if( !result )
					console.warn( "[ProjectDashboard] Project was not found at deletion! Redirecting to Projects listing anyway." );
				this.$router.push( { name : 'projects', params : { nodeId : this.nodeId } } );
			} catch( err ) {
				console.error( err );
				alert( "Project could not be deleted!\n"+ err.message );
			}
		},
		getProject( )
		{
			return this.$store.getters['projects/project']( this.nodeId, this.projectId );
		},
		resetProject( )
		{
			this.projectSettings = _.cloneDeep( this.getProject( ) );
			this.projectSharing = { };
			const sharing = this.projectSettings.sharing || { };
			for( let user in sharing )
			{
				const rights = sharing[user];
				if( rights.admin === true )
					this.projectSharing[user] = "admin";
				else if( rights.write === true )
					this.projectSharing[user] = "write";
				else if( rights.read === true )
					this.projectSharing[user] = "read";
			}
		},
		setEditorProject( project )
		{
			project = project || this.projectSettings;	//this.$store.state.projects.lookup[this.nodeId][this.projectId];
			if( project && this.editor )
			{
				let editorProject = _.omit( project, [ '$created', '$modified', '$version', '$node' ] );
				if( this.newOwner )
					editorProject.owner = this.newOwner;
				this.editor.setValue( JSON.stringify( editorProject, null, 2 ), -1 );
			}
		},
		async saveEditorProject( )
		{
			// TODO: Set loading overlay
			let project;

			try {
				project = JSON.parse( this.editor.getValue( ) );
			} catch( err ) {
				alert( "Could not save the object:\n"+ err.message );
				console.error( err );
				return;
			}

			let id = this.getProject( ).$id;

			try {
				let result = await this.updateProject( { nodeId : this.nodeId, projectId : id, updates : project } );
				if( !id || null === result )
					throw new Error( "This project is no longer found in the repository!" );
				
				// TODO: close loading overlay

			} catch( err ) {

				// TODO: Switch loading overlay to ERROR overlay.

				console.warn( "Project save failed:", err );

				// TODO: Set this action, as the result of dismissing the ERROR OVERLAY
				this.$router.push( { name : 'projects', params : { nodeId : this.nodeId } } );
			}
		},
		...mapActions({
			readProject: "projects/read",
			updateProject: "projects/update",
			deleteProject: "projects/delete",
		}),
	},
	async mounted( )
	{
		try {
			this.editor = ace.edit( "editor", {
				mode: "ace/mode/json",
				theme: "ace/theme/tomorrow",	//"ace/theme/dracula",
				maxLines: 20,
				minLines: 5,
				fontSize: 14,
				showPrintMargin : false
			});
			await this.refreshProject( );
		} catch( err ) { throw err; }
		this.accountList = await this.listAccounts( { nodeId : this.nodeId } );
	}
};
</script>

<style scoped>
div#editor
{
	border: 1px solid #666;
}
h2 {
	font-weight: normal;
}
</style>


// WEBPACK FOOTER //
// src/components/ProjectDashboard.vue